export default __webpack_public_path__ + "static/media/training.a4f87e58.png";